export const CUSTOM_SHADOW_MIN_ALPHA = 0;
export const CUSTOM_SHADOW_MIN_DISPLAY_ALPHA = 0;
export const CUSTOM_SHADOW_MAX_ALPHA = 1;
export const CUSTOM_SHADOW_MAX_DISPLAY_ALPHA = 100;
